import { Component, inject, OnInit } from '@angular/core';
import { SwUpdate,VersionReadyEvent } from '@angular/service-worker';
import {filter, map} from 'rxjs/operators';
import { register } from 'swiper/element/bundle';
import { AuthenticateService } from './services/authenticate.service';
import { SocketWebService } from './services/socket-web.service';
import { Platform } from '@ionic/angular';
import { VersionCheck } from './services/version-check';

register();

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit{
  modalVersion: boolean;

   private authService = inject(AuthenticateService);
  private socketWebService = inject(SocketWebService);
  constructor(private updates: SwUpdate,private platform: Platform,private versionCheck: VersionCheck) {
//     updates.available.subscribe((ev) => {

//       console.log('Updating to latest version.');
//       this.updates.activateUpdate().then(() =>{
//          if (this.updates.isEnabled) {
//                 if (confirm(`Hay una actualizacion disponible?`)) {
//                   window.location.reload();
//                 }
//           }
//   });
// });
// if (updates.isEnabled) {
//   updates.versionUpdates.pipe(
//     filter((evt: any): evt is VersionReadyEvent => evt.type === 'VERSION_READY'),
//     map((evt: any) => {
//       console.log(`currentVersion=[${evt.currentVersion} | latestVersion=[${evt.latestVersion}]`);
//         this.modalVersion = true;
//     }),
//   );
// }

if ('caches' in window) {
  caches.keys().then(keys => {
    keys.forEach(k => caches.delete(k));
  });
this.initializeApp();
}
updates.versionUpdates.subscribe(async evt => {
  console.log('UpdateService: versionUpdates now', evt);
  switch (evt.type) {
      case 'VERSION_DETECTED':
          console.log(`Downloading new app version: ${evt.version.hash}`);
          break;
      case 'VERSION_READY':
         alert('Hay una version nueva');
          console.log(`Current app version: ${evt.currentVersion.hash}`);
          console.log(`New app version ready for use: ${evt.latestVersion.hash}`);
          await updates.activateUpdate();
          location.reload();
          break;
      case 'VERSION_INSTALLATION_FAILED':
          console.log(`Failed to install app version '${evt.version.hash}': ${evt.error}`);
          break;
  }
});
  }
  ngOnInit(): void {
this.revisarSesionYReconectarSocket();
  }
revisarSesionYReconectarSocket() {
    // 1. Revisa si hay una identidad guardada en localStorage.
    const identity = this.authService.getIdentityFromStorage();

    // 2. Si existe una identidad, significa que el usuario ya había iniciado sesión.
    if (identity) {
      // console.log('Sesión encontrada al iniciar la app. Reconectando socket...');
      // 3. Llama al método para reconectar el socket con los datos correctos.
      this.socketWebService.reconnectWithNewIdentity();
    } else {
      // console.log('No hay sesión activa al iniciar la app.');
    }
  }
initializeApp() {
  console.log(' , initializing version ...');
    this.platform.ready().then(() => {

      this.platform.resume.subscribe(() => {
        console.log('App regresó del background (Resume) ⚡');
        
        // Verificamos y forzamos reconexión si es necesario
        this.socketWebService.checkConnection(); 
      });
      // ... tu código de splash screen etc ...
  //  console.log('Platform ready, initializing version check...');
      // LLAMADA AL CHECK DE VERSION
      // Le damos un pequeño delay para no chocar con el Splash Screen
      setTimeout(() => {
          this.versionCheck.checkForUpdate();
      }, 2000);
    });
  }
}
